
(function () {
  function applyStaticGate(root) {
    var checkbox = root.querySelector('[data-age-gate-checkbox]');
    var overlay = root.querySelector('[data-age-gate-overlay]');
    var checkoutBtn = root.querySelector('[data-age-gate-checkout]');

    if (checkbox) {
      if (checkbox.dataset.gateBound === 'true') return;
      checkbox.dataset.gateBound = 'true';

      function apply() {
        var confirmed = checkbox.checked;
        if (checkoutBtn) checkoutBtn.disabled = !confirmed;
        if (overlay) overlay.style.display = confirmed ? 'none' : 'block';
      }
      checkbox.addEventListener('change', apply);
      apply();
    } else if (overlay) {
      if (overlay.dataset.gateBound === 'true') return;
      overlay.dataset.gateBound = 'true';

      overlay.addEventListener('click', function (e) {
        e.preventDefault();
        e.stopPropagation();
        if (typeof window.__ageVerifyOpen === 'function') {
          window.__ageVerifyOpen(function () {
            overlay.style.display = 'none';
          });
        } else {
          overlay.style.display = 'none';
        }
      });
    }
  }

  function applyLiveCheckGate(root) {
    var checkboxWrap = root.querySelector('[data-age-gate-live-wrap]');
    var checkbox = root.querySelector('[data-age-gate-checkbox]');
    var checkoutBtn = root.querySelector('[data-age-gate-checkout]');
    if (!checkbox || !checkoutBtn) return;
    if (root.dataset.gateChecking === 'true') return;
    root.dataset.gateChecking = 'true';

    var runId = (root.dataset.gateRunId = String(Date.now() + Math.random()));

    fetch(window.Shopify && window.Shopify.routes && window.Shopify.routes.root
      ? window.Shopify.routes.root + 'cart.js'
      : '/cart.js', { credentials: 'same-origin' })
      .then(function (r) { return r.json(); })
      .then(function (cart) {
        if (root.dataset.gateRunId !== runId) return; // stale response, root re-scanned meanwhile
        var ids = window.__alcoholProductIds || [];
        var hasAlcohol = (cart.items || []).some(function (item) {
          return ids.indexOf(item.product_id) !== -1;
        });

        if (hasAlcohol) {
          if (checkboxWrap) checkboxWrap.hidden = false;
          if (checkbox.dataset.gateBound !== 'true') {
            checkbox.dataset.gateBound = 'true';
            checkbox.addEventListener('change', function () {
              checkoutBtn.disabled = !checkbox.checked;
            });
          }
          checkoutBtn.disabled = !checkbox.checked;
        } else {
          if (checkboxWrap) checkboxWrap.hidden = true;
          checkoutBtn.disabled = false;
        }
      })
      .catch(function () {
        // network failure: fail safe, keep default disabled state already set in markup
      })
      .then(function () {
        root.dataset.gateChecking = 'false';
      });
  }

  function setup(root) {
    if (root.hasAttribute('data-age-gate-live-check')) {
      applyLiveCheckGate(root);
    } else {
      applyStaticGate(root);
    }
  }

  function scan() {
    document.querySelectorAll('[data-age-gate-root]').forEach(setup);
  }

  scan();
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', scan);
  }

  var observer = new MutationObserver(function () {
    scan();
  });
  function startObserving() {
    observer.observe(document.body, { childList: true, subtree: true });
  }
  if (document.body) {
    startObserving();
  } else {
    document.addEventListener('DOMContentLoaded', startObserving);
  }
})();
